import {Component, HostBinding, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'motn-spinner',
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() wholeScreen: boolean = false;
  @Input() @HostBinding('class.centered') centered: boolean = false;
}
